import { Injectable, signal, computed } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {    
  private rolesSubject = new BehaviorSubject<string[] | null>(null);

  // Observable for consumers to subscribe to
  roles$: Observable<string[]> = this.rolesSubject.pipe(
    filter((roles): roles is string[] => roles !== null) // only emit when actually set
  );

  setRoles(roles: string[]): void {
    this.rolesSubject.next(roles);
  }

  getRoles(): string[] {
    return this.rolesSubject.getValue() ?? [];
  }

  getRolesAsString(): string {
    return this.getRoles().join(',');
  }

  hasRoles(): boolean {
    return this.rolesSubject.getValue() !== null;
  }
  
  clearRoles(): void {
    this.rolesSubject.next(null);
  }
}